import { createReducer } from 'typesafe-actions';
import * as actions from './uiControl.actions';
import { Alert, Entry, ShipData, PortData, Species, Bulletin } from '../../services/types';
import { loginUser } from '../user/user.actions';


export enum Display {
  PORT = 'PORT',
  SHIP = 'SHIP',
  ENTRY = 'ENTRY',
  SPECIES = 'SPECIES',
  BULLETIN = 'BULLETIN'
}

export interface UiControlState {
  alert: Alert | null;
  selectedImage: string | null;
  selectedEntry: Entry | null;
  selectedShip: ShipData | null;
  selectedPort: PortData | null;
  isShowingImages: boolean;
  showing: Display | null;
  selectedSpecies: Species | null;
  selectedBulletin: Bulletin | null;
  showLogin: boolean;

}

export const uiControlState: UiControlState = {
  alert: null,
  selectedImage: null,
  selectedEntry: null,
  selectedShip: null,
  selectedPort: null,
  isShowingImages: false,
  showing: null,
  selectedSpecies: null,
  selectedBulletin: null,
  showLogin: false

};

export default createReducer<UiControlState>(uiControlState)
  .handleAction(actions.toggleFullSize, (state, action) => {
    let selectedImage = null;
    if( action.payload !== state.selectedImage){
      selectedImage = action.payload;
    }

    return {
      ...state,
      selectedImage: selectedImage,
    };
  })
  .handleAction([actions.setShowImages], (state, action) =>{
    return {
      ...state,
      isShowingImages: action.payload
    };
  })
  .handleAction(
    actions.toggleDisplays,
    (state, action) => {

      const selected = action.payload;
      if (!selected) return state;
      if(selected.type === "bulletin"){
        return {
          ...state,
          selectedBulletin: selected as Bulletin,
          showing: Display.BULLETIN,
          selectedImage: null,
          selectedEntry: null
        };
      }else{
        return {
          ...state,
          selectedEntry: selected as Entry,
          showing: Display.ENTRY,
          selectedImage: null,
          selectedBulletin: null,
        };
      }
    }
  )
  .handleAction(
    [actions.closeDisplays],
    (state, action) => {
      return {
        ...state,
        showing: null,
      };
    }
  )
  .handleAction(
    actions.toggleShip,
    (state, action) => {
      const selectedShip = action.payload;
      if (!selectedShip) return state;
      
      return {
        ...state,
        selectedShip: selectedShip,
        showing: Display.SHIP,
      };
    }
  )
  .handleAction(
    actions.togglePort,
    (state, action) => {
      const selectedPort = action.payload;
      if (!selectedPort) return state;
      
      return {
        ...state,
        selectedPort: selectedPort,
        showing: Display.PORT,
      };
    }
  )
  .handleAction(
    actions.selectSpecies,
    (state, action) => {
      const selectedSpecies = action.payload;
      if (!selectedSpecies) return state;
      
      return {
        ...state,
        selectedSpecies: selectedSpecies,
        showing: selectedSpecies.id === 'Default' ? null : Display.SPECIES,
        selectedImage: null,

      };
    }
  )
  .handleAction(
    actions.selectBulletin,
    (state, action) => {
      const selectedBulletin = action.payload;
      if (!selectedBulletin) return state;
      
      return {
        ...state,
        selectedBulletin: selectedBulletin,
        showing: selectedBulletin.id === 'Default' ? null : Display.BULLETIN,
        selectedImage: null,

      };
    }
  )
  .handleAction(
    actions.toggleLogin,
    (state, action) => {
      return {
        ...state,
        showLogin: !state.showLogin
      };
    }
  )
  .handleAction(
    loginUser.success,
    (state, action) => {
      return {
        ...state,
        showLogin: false
      };
    }
  )
  .handleAction(
    actions.displayAlert,
    (state, action) => {
      return {
        ...state,
        alert: action.payload,
      };
    }
  );

  